$(function () {
  // Timeout feature added to prevent email spamming through mashing enter button. - James - Nov 6, 2015
  var enterTimeout = 0;
  $('input').keypress(function (e) {
    if (e.which == 13) {
      if (enterTimeout == 1) {
        e.preventDefault() || e.preventDefault;
        e.stopPropagation() || e.stopPropagation;
        console.log('stopped');
        return false;
      }
      $('.button[data-label="' + $(this).attr('data-submit') + '"]').click();
      enterTimeout = 1;
      setTimeout(function () {
        enterTimeout = 0;
      }, 5000);
      return false;
    }
  });

  $('input.phone').change(function (e) {
   		$(this).val(formatPhoneNumber($(this).val()));
  });
  $('input.phone').keyup(function (e) {
    // If number, reformat
    if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {
       		$(this).val(formatPhoneNumber($(this).val()));
    }
  });
  $('input.phone').keydown(function (e) {
    // Allow: backspace, delete, tab, escape and enter
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
        		// Allow: Ctrl+A
	            (e.keyCode == 65 && e.ctrlKey === true) ||
        		// Allow: Ctrl+V
	            (e.keyCode == 86 && e.ctrlKey === true) ||
        		// Allow: Ctrl+C
	            (e.keyCode == 67 && e.ctrlKey === true) ||
	            // Allow: home, end, left, right, down, up
	            (e.keyCode >= 35 && e.keyCode <= 40)) {
        	// let it happen, don't do anything
        	return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) || $(this).val().length == 21) {
        	e.preventDefault();
    }
  });

  $("input[type='text'], input[type='password'], input[type='email'], input[type='tel']").each(function () {
    var label = $(this).attr('data-label');
    $(this).val(label);
    $(this).addClass('input_data_label_default');
    if ($(this).attr('type') == 'password') {
      $(this).attr('type', 'text').attr('autocomplete', 'off');
      $(this).addClass('input_data_label_password');
    }
  });

  $("input[type='text'], input[type='password'], input[type='email'], input[type='tel']").focus(function (e) {
    e.preventDefault();
    if ($.trim($(this).val()) == $.trim($(this).attr('data-label'))) {
      $(this).val('');
    }
    $(this).removeClass('input_data_label_default');
    if ($(this).hasClass('input_data_label_password')) {
      $(this).attr('type', 'password');
      $(this).removeClass('input_data_label_password');
    }
  });

  $("input[type='text'], input[type='password'], input[type='email'], input[type='tel']").blur(function () {
    if ($(this).val() === '') {
      $(this).addClass('input_data_label_default');
      var label = $(this).attr('data-label');
      $(this).val(label);

      if ($(this).attr('type') == 'password') {
        $(this).attr('type', 'text');
        $(this).addClass('input_data_label_password');
      }
    }
  });

  function formatPhoneNumber(val) {
    val = val.replace(/\D/g, '');
    if (val.length == 0) {
      return val;
    } else if (val.length < 3) {
      val = '(' + val.substring(0);
      return val;
    } else if (val.length <= 6) {
      val = '(' + val.substring(0, 3) + ') ' + val.substring(3);
    } else if (val.length <= 10) {
      val = '(' + val.substring(0, 3) + ') ' + val.substring(3, 6) + '-' + val.substring(6);
    } else {
      val = '(' + val.substring(0, 3) + ') ' + val.substring(3, 6) + '-' + val.substring(6, 10) + ' x' + val.substring(10, 15);
    }

    return val;
  }
});
